export default __webpack_public_path__ + "static/media/EarthId-KYS-01.ad1917e5.png";